var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-router-view"},[_c('div',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.pluginUrl))]),(!!_vm.cmp)?_c(_vm.cmp,_vm._b({tag:"component"},'component',_vm.viewData,false)):_c('div',{staticClass:"zj-errmsg"},[_c('span',[_vm._v(_vm._s(_vm.errmsg))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }